import {get, limitToLast, orderByChild, query, ref, remove, update} from "firebase/database";
import {database} from "../utils/firebase";
import {ADMIN_CONFIG_PATHS} from "../config/adminConfig";

const WIT_AUDIT_PATH = ADMIN_CONFIG_PATHS.witAudit;
export const WIT_AUDIT_PAGE_SIZE = 100;
// TODO: Add updatedAt/key cursor pagination before exposing audit history beyond this bounded page.

const normalizeAuditEntries = (value) => {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value.filter(Boolean);
  }
  if (Array.isArray(value.entries)) {
    return value.entries.filter(Boolean);
  }
  return Object.entries(value).map(([id, entry]) => ({id, ...entry}));
};

const sortEntries = (entries) => [...entries].sort((a, b) => {
  const aTime = new Date(a.updatedAt || a.createdAt || 0).getTime();
  const bTime = new Date(b.updatedAt || b.createdAt || 0).getTime();
  return bTime - aTime;
});

const witAuditService = {
  async loadAuditEntries() {
    const snapshot = await get(query(
      ref(database, WIT_AUDIT_PATH),
      orderByChild("updatedAt"),
      limitToLast(WIT_AUDIT_PAGE_SIZE),
    ));
    if (!snapshot.exists()) {
      return {entries: [], containsLegacyEntries: false};
    }
    const entries = sortEntries(normalizeAuditEntries(snapshot.val()));
    return {
      entries,
      containsLegacyEntries: entries.some((entry) => !entry.updatedAt),
    };
  },

  async clearAuditEntries() {
    await remove(ref(database, WIT_AUDIT_PATH));
  },

  async saveReview(entryId, reviewPatch) {
    await update(ref(database, `${WIT_AUDIT_PATH}/${entryId}`), reviewPatch);
  },
};

export default witAuditService;
